exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".time-event[data-v-251fb193]{display:flex;align-items:center;justify-content:center;text-align:center;height:100%;width:100%}.event[data-v-251fb193]{width:100%;display:inline-block;vertical-align:top;margin:12px 6px!important}@media (min-width:770px){.event[data-v-251fb193]{width:32%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-251fb193","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Search.vue
// module id = 184
// module chunks = 0